import type { Component } from "solid-js";
import { BookmarksPage } from "../views/BookmarksPage";
import { DashboardPage } from "../views/DashboardPage";
import { IncidentsPage } from "../views/IncidentsPage";
import { ProfilesPage } from "../views/ProfilesPage";
import { ReportsPage } from "../views/ReportsPage";
import { CalendarPage } from "../views/CalendarPage";
import { ChargesPage } from "../views/ChargesPage";
import { ConfigPage } from "../views/ConfigPage";
import { DocketPage } from "../views/DocketPage";
import { EvidencePage } from "../views/EvidencePage";
import { FtoReportsPage } from "../views/FtoReportsPage";
import { LegislationPage } from "../views/LegislationPage";
import { PropertiesPage } from "../views/PropertiesPage";
import { SharedReportsPage } from "../views/SharedReportsPage";
import { StaffPage } from "../views/StaffPage";
import { VehiclesPage } from "../views/VehiclesPage";

export type ViewName =
  | "Dashboard"
  | "Bookmarks"
  | "Profiles"
  | "Incidents"
  | "Reports"
  | "Evidence"
  | "Vehicles"
  | "Properties"
  | "Charges"
  | "Staff"
  | "FTO Reports"
  | "Legislation"
  | "Calendar"
  | "Shared Reports"
  | "Docket"
  | "Config";

export type TabRecord = {
  id: number;
  name: ViewName;
  title: string;
};

export const viewComponents: Record<ViewName, Component> = {
  Dashboard: DashboardPage,
  Bookmarks: BookmarksPage,
  Profiles: ProfilesPage,
  Incidents: IncidentsPage,
  Reports: ReportsPage,
  Evidence: EvidencePage,
  Vehicles: VehiclesPage,
  Properties: PropertiesPage,
  Charges: ChargesPage,
  Staff: StaffPage,
  "FTO Reports": FtoReportsPage,
  Legislation: LegislationPage,
  Calendar: CalendarPage,
  "Shared Reports": SharedReportsPage,
  Docket: DocketPage,
  Config: ConfigPage,
};
